import { makeRule } from '@core/utils/rule.js'

export let formRules = {
  oldPassword: [
    {...makeRule('请输入旧密码', 'string')},
  ],
  newPassword: [
    {...makeRule('请输入新密码', 'string')},
  ],
  newPasswordRpt: [
    {...makeRule('请重复输入新密码', 'string')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/settings/settins.rules.js